import { makeStyles } from 'tss-react/mui';

const useStylesUploadFile: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  containerUploadFile: {
    fontWeight: 500,
    fontSize: 16,
    textAlign: 'center',
    '& > div': {
      display: 'inline-flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
    '& button > span': {
      color: theme.palette.secondary.main,
    },
    '& input[type=file]': {
      display: 'none',
    },
  },
  containerUploadFileInline: {
    textAlign: 'inherit !important',
  },
  containerUploadFileRow: {
    display: 'flex !important',
  },
  uploadFilePreviewBlock: {
    maxWidth: 300,
    whiteSpace: 'normal',
    fontSize: 14,
    fontWeight: 'normal',
    wordBreak: 'break-all',
  },
  uploadFilePreviewBlockInline: {
    marginLeft: 10,
    whiteSpace: 'nowrap',
    wordBreak: 'normal',
  },
  uploadFilePreviewBlockMultiple: {
    whiteSpace: 'normal',
    maxWidth: 'none',
  },
  uploadFileError: {
    color: theme.palette.error.main,
    margin: '5px !important',
    float: 'right',
    fontSize: 14,
    paddingTop: 10,
  },
  uploadFilePreviewFile: {
    display: 'inline-flex',
    '& > div': {
      margin: 10,
    },
  },
  uploadFileDropTargetBox: {
    width: 250,
    height: 50,
    marginBottom: 0,
    padding: 14,
    fontSize: 14,
    fontWeight: 400,
    color: theme.palette.common.black,
    border: `1px dashed ${theme.palette.info.main}`,
    textAlign: 'center',
    cursor: 'default',
    [theme.breakpoints.down('sm')]: {
      width: 150,
    },
  },
  uploadFileDropTargetBoxImage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 120,
    height: 120,
    padding: 0,
  },
  uploadFileDropTargetBoxInline: {
    whiteSpace: 'pre-wrap',
    marginBottom: 0,
    [theme.breakpoints.down('md')]: {
      width: 120,
    },
  },
  uploadFileDropTargetBoxActive: {
    color: `${theme.palette.secondary.main} !important`,
    border: `1px dashed ${theme.palette.secondary.main} !important`,
  },
  uploadFileDropTargetBoxListImage: {
    width: 65,
    height: 65,
  },
  uploadFileDropTargetBoxSmallImage: {
    width: 70,
    height: 70,
  },
  uploadFileDropTargetBoxLight: {
    color: `${theme.palette.common.white} !important`,
  },
  uploadFileDropTargetBoxNarrow: {
    height: 45,
    padding: 10,
  },
  uploadFilePreviewImage: {
    maxWidth: 60,
    maxHeight: 60,
  },
  uploadFilePreviewImageList: {
    maxWidth: 50,
    maxHeight: 50,
  },
  uploadFilePreviewImageSmall: {
    maxWidth: 50,
    maxHeight: 50,
  },
  uploadFilePreviewImageLarge: {
    maxWidth: '100px !important',
    maxHeight: '100px !important',
  },
}));

export default useStylesUploadFile;
